import MusicMixList from "../components/MusicMixList/MusicMixList";

const MyMixes = (): JSX.Element => {
    return(
        <MusicMixList />
    )
  }
  
  export default MyMixes;
  